import styled from "styled-components";

const ColumnLayout = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  flex-direction: row;
`;

export default ColumnLayout;
